import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import CustomStore from 'devextreme/data/custom_store';
import { LoadOptions } from 'devextreme/data';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataSourceService {
  constructor(private http: HttpClient) { }

  getDataSource(apiUrl: string): CustomStore {
    const isNotEmpty = (value: unknown) => (value !== undefined && value !== null && value !== '');
    const http = this.http

    return new CustomStore({
      key: 'id',
      async load(loadOptions: LoadOptions) {
        let params = new HttpParams();

        Object.keys(loadOptions).forEach((key) => {
          const value = loadOptions[key as keyof LoadOptions];
          if (isNotEmpty(value)) {
            params = params.set(key, JSON.stringify(value));
          }
        });

        const sort = loadOptions.sort;

        if (Array.isArray(sort)) {
          if (
            sort.length === 1 && typeof sort[0] !== 'string' && 'selector' in sort[0] && sort[0].selector === 'id' && !sort[0].desc
          ) {// Eğer "sort" 'id asc' olarak geldiyse, bunu 'id desc' yap
            params = params.set('sort', JSON.stringify([{ selector: 'id', desc: true }]));
          } else {// Gelen sıralamayı olduğu gibi kullan
            params = params.set('sort', JSON.stringify(sort));
          }
        } else {// Eğer sort parametresi yoksa, varsayılan olarak 'id desc' ayarla
          params = params.set('sort', JSON.stringify([{ selector: 'id', desc: true }]));
        }

        try {
          // Veriyi API'den almak
          const result = await lastValueFrom(http.get(`${apiUrl}`, { params })) as Record<string, unknown>;

          // Veriyi DataGrid'e döndürmek
          return { data: result['data'], totalCount: result['totalCount'], summary: result['summary'], groupCount: result['groupCount'] };
        } catch (err) {
          throw new Error('Data Loading Error');
        }
      },
    });

  }
}
